import script from "./Sandbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Sandbox.vue?vue&type=script&setup=true&lang=js"

import "./Sandbox.vue?vue&type=style&index=0&id=062c7583&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-062c7583"]])

export default __exports__